import { render } from "./gbjg.vue?vue&type=template&id=0a326fec&scoped=true&ts=true"
import script from "./gbjg.vue?vue&type=script&lang=ts"
export * from "./gbjg.vue?vue&type=script&lang=ts"

import "./gbjg.vue?vue&type=style&index=0&id=0a326fec&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a326fec"]])

export default __exports__